<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { range } from 'lodash-es';
import store from '../../../store';
import i18n from '../../../i18n';

export default {
  name: 'SkiSchoolPrices',
  data() {
    return {
      newPrice: {
        skiSchoolLessonTypeId: undefined,
        skiSchoolSkiTypeId: undefined,
        numberOfPersons: undefined,
        days: undefined,
        durationMinutes: undefined,
        price: undefined,
        commissionRatio: undefined,
        contributionRatio: undefined,
        webActive: true,
      },
      newPriceCombination: {
        priceId: undefined,
        skiSchoolSeasonLevelId: undefined,
        skiSchoolSeasonPersonCategoryId: undefined,
      },
      dataHeaders: [
        { text: this.$t('skiSchool.priceTableHeaders.lessonType'), sortable: false, width: '10%' },
        { text: this.$t('skiSchool.priceTableHeaders.skiType'), sortable: false, width: '10%' },
        { text: this.$t('skiSchool.priceTableHeaders.persons'), sortable: false, width: '5%' },
        { text: this.$t('skiSchool.priceTableHeaders.minutes'), sortable: false, width: '5%' },
        { text: this.$t('skiSchool.priceTableHeaders.days'), sortable: false, width: '5%' },
        { text: this.$t('skiSchool.priceTableHeaders.price'), sortable: false, width: '15%' },
        { text: '%', sortable: false, width: '15%' },
        { text: this.$t('skiSchool.priceTableHeaders.webActive'), sortable: false, width: '15%' },
        { text: '', sortable: false, width: '5%' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      levels: 'skischool/getLevels',
      skiLessonTypes: 'skischool/getLessonTypes',
      skiTypes: 'skischool/getSkiTypes',
      personCategories: 'skischool/getPersonCategoriesWithAllOption',
      pricesWithNames: 'skischool/getPricesWithNames',
    }),
    ...mapState({
      season: state => state.skischool.season,
      prices: state => state.skischool.season.prices.items,
      pricesLoading: state => state.skischool.season.prices.itemsLoading,
      pricesError: state => state.skischool.season.prices.itemsError,
      pricesSaveLoading: state => state.skischool.season.prices.saveLoading,
      pricesSaveError: state => state.skischool.season.prices.saveError,
      activePriceId: state => state.skischool.season.prices.activePriceId,
      personCategoriesLoading: state => state.skischool.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skischool.season.personCategories.itemsError,
      levelsLoading: state => state.skischool.season.levels.itemsLoading,
      levelsError: state => state.skischool.season.levels.itemsError,
      lessonTypesLoading: state => state.skischool.lessonTypes.itemsLoading,
      lessonTypesError: state => state.skischool.lessonTypes.itemsError,
      skiTypesLoading: state => state.skischool.skiTypes.itemsLoading,
      skiTypesError: state => state.skischool.skiTypes.itemsError,
    }),
    availableDays() {
      return range(1, 15);
    },
    availableNumberOfPersons() {
      return range(1, 11);
    },
    availableMinutes() {
      return range(1, 361);
    },
    availableStartWeekDays() {
      return [
        { id: 1, name: this.$t('weekDays.monday') },
        { id: 2, name: this.$t('weekDays.tuesday') },
        { id: 3, name: this.$t('weekDays.wednesday') },
        { id: 4, name: this.$t('weekDays.thursday') },
        { id: 5, name: this.$t('weekDays.friday') },
        { id: 6, name: this.$t('weekDays.saturday') },
        { id: 0, name: this.$t('weekDays.sunday') },
      ];
    },
    canCreateNewPrice() {
      return this.newPrice.skiSchoolLessonTypeId
        && this.newPrice.skiSchoolSkiTypeId
        && this.newPrice.numberOfPersons
        && this.newPrice.days
        && this.newPrice.durationMinutes
        && this.newPrice.price >= 0
        && this.newPrice.commissionRatio >= 0
        && this.newPrice.contributionRatio >= 0
        && this.newPrice.webActive !== undefined;
    },
    errorOccurred() {
      return this.pricesSaveError
        || this.pricesError
        || this.lessonTypesError
        || this.skiTypesError
      ;
    },
    loading() {
      return this.pricesLoading
        || this.pricesSaveLoading
        || this.personCategoriesLoading
        || this.levelsLoading
        || this.lessonTypesLoading
        || this.skiTypesLoading;
    },
  },
  methods: {
    ...mapActions({
      loadLevels: 'skischool/levelsByIdLoad',
      loadLessonTypes: 'skischool/lessonTypesLoad',
      loadSkiTypes: 'skischool/skiTypesLoad',
      loadPersonCategories: 'skischool/personCategoriesByIdLoad',
      loadPricesBySeasonId: 'skischool/pricesBySeasonIdLoad',
      priceCreate: 'skischool/priceCreate',
      priceSet: 'skischool/setPrice',
      priceSave: 'skischool/priceSave',
      priceDelete: 'skischool/priceDelete',
      startDayOnPriceSave: 'skischool/startDayOnPriceSave',
      startDayOnPriceDelete: 'skischool/startDayOnPriceDelete',
      priceCombinationAdd: 'skischool/priceCombinationAdd',
      priceCombinationDelete: 'skischool/priceCombinationDelete',
    }),
    createPrice() {
      this.newPrice.skiSchoolSeasonId = this.season.id;
      this.priceCreate(this.newPrice);
    },
    onPriceChange(price, params) {
      this.priceSet({
        price,
        params,
      });
    },
    savePrice(price) {
      this.priceSave(price);
    },
    removePrice(priceId) {
      // eslint-disable-next-line no-alert
      if (confirm(i18n.t('ski.skiPrice.removeAreYouSure'))) {
        this.priceDelete(priceId);
      }
    },
    onNewPriceChange(params) {
      this.newPrice = {
        ...this.newPrice,
        ...params,
      };
    },
    syncSelectedWeekdaysToBeAddedOrDeleted(newSelectedWeekdays, price) {
      const priceId = price.id;
      const currentWeekdays = price.priceStartDays;
      Object.values(currentWeekdays).forEach((oldWeekdayNumber) => {
        const selectedWeekDay = newSelectedWeekdays.find(
          newWeekday => newWeekday === oldWeekdayNumber,
        );
        if (!selectedWeekDay) {
          this.startDayOnPriceDelete({ priceId, weekdayNumber: oldWeekdayNumber });
        }
      });
      newSelectedWeekdays.forEach((newWeekdayNumber) => {
        const selectedWeekdayNumber = currentWeekdays.find(
          oldWeekdayNumber => oldWeekdayNumber === newWeekdayNumber,
        );
        if (!selectedWeekdayNumber) {
          this.startDayOnPriceSave({
            priceId,
            weekdayNumber: newWeekdayNumber,
          });
        }
      });
    },
    setNewPriceCombination(priceId, params) {
      if (this.newPriceCombination.priceId !== priceId) {
        this.newPriceCombination.priceId = priceId;
        this.newPriceCombination.skiSchoolSeasonLevelId = undefined;
        this.newPriceCombination.skiSchoolSeasonPersonCategoryId = undefined;
      }
      this.newPriceCombination = {
        ...this.newPriceCombination,
        ...params,
      };
    },
    canAddPriceCombination(price) {
      if (price.id !== this.newPriceCombination.priceId
        || !this.newPriceCombination.skiSchoolSeasonLevelId
        || !this.newPriceCombination.skiSchoolSeasonPersonCategoryId
      ) {
        return false;
      }
      const priceCombinationAlreadyExists = Object.values(price.priceCombinations).find(
        item => item.skiSchoolSeasonLevelId === this.newPriceCombination.skiSchoolSeasonLevelId
          && item.skiSchoolSeasonPersonCategoryId
            === this.newPriceCombination.skiSchoolSeasonPersonCategoryId,
      );
      return priceCombinationAlreadyExists === undefined;
    },
    addPriceCombination(priceId) {
      this.priceCombinationAdd({
        priceId,
        seasonId: this.season.id,
        newPriceCombination: this.newPriceCombination,
      });
    },
    removePriceCombination(priceId, priceCombinationId) {
      // eslint-disable-next-line no-alert
      if (confirm(i18n.t('ski.skiPrice.priceCombination.removeAreYouSure'))) {
        this.priceCombinationDelete({
          priceId,
          priceCombinationId,
        });
      }
    },
    doRefresh() {
      this.loadLessonTypes();
      this.loadSkiTypes();
      this.loadPersonCategories(this.season.id);
      this.loadLevels(this.season.id);
      this.loadPricesBySeasonId(this.season.id);
    },
    getCommissionOrContributionHeader() {
      const headerText = this.season.netOrGross === 'net'
        ? i18n.t('ski.skiPrice.dataHeaders.contribution')
        : i18n.t('ski.skiPrice.dataHeaders.commission');
      const ratioPercentage = this.season.netOrGross === 'net'
        ? this.season.contributionRatio
        : this.season.commissionRatio;

      return headerText.concat(': ').concat(ratioPercentage).concat('%');
    },
    scrollToPrice(priceId) {
      const targetElement = 'price-'.concat(priceId);
      if (document.getElementById(targetElement)) {
        this.$vuetify.goTo(
          '#'.concat(targetElement),
          {
            duration: 1500,
            offset: 0,
            easing: 'easeInOutCubic',
          },
        );
      }
    },
  },
  watch: {
    loading: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.activePriceId) {
            this.scrollToPrice(this.activePriceId);
          }
        });
      },
    },
  },
  mounted() {
    if (this.season.id) {
      if (!this.levels || !this.levels.length) {
        this.loadLevels(this.season.id);
      }
      if (!this.personCategories || !this.personCategories.length) {
        this.loadPersonCategories(this.season.id);
      }
      if (!this.prices || !this.prices.length) {
        this.loadPricesBySeasonId(this.season.id);
      }
      if (this.newPrice.commissionRatio === undefined
        || this.newPrice.contributionRatio === undefined
      ) {
        if (this.season.netOrGross === 'net') {
          this.newPrice.contributionRatio = this.season.contributionRatio;
          this.newPrice.commissionRatio = 0;
        } else {
          this.newPrice.contributionRatio = 0;
          this.newPrice.commissionRatio = this.season.commissionRatio;
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skischool/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
    store.dispatch('skischool/skiTypesLoad')
      .finally(() => {
        next();
      });
    store.dispatch('skischool/lessonTypesLoad')
      .finally(() => {
        next();
      });
  },
};
</script>
<template>
  <v-container class="pa-0">
    <h2 class="pb-3 d-inline-block">
      {{ $t('skiSchool.dataHeaders.prices') }}
    </h2>
    <v-btn
      @click="doRefresh()"
      :loading="loading"
      icon
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <v-card
      v-if="personCategories.length && levels.length"
      class="pa-3 mx-auto"
      outlined
    >
      <v-layout>
        <v-flex class="font-weight-bold" sm12 xs12>
          <h3>{{ $t('ski.skiPrice.newPrice') }} ({{ getCommissionOrContributionHeader() }})</h3>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex sm12 xs12>
          <h3>
            {{ $t('ski.supplier-currency') }}:
            <template v-if="season.supplier">
              {{ season.supplier.currency }}
              ({{ season.supplier.name }})
            </template>
          </h3>
        </v-flex>
      </v-layout>
      <v-alert
        v-if="errorOccurred"
        :value="errorOccurred"
        color="error"
        icon="warning"
        outline
      >
        <span v-html="errorOccurred"></span>
      </v-alert>
      <v-layout class="pt-2">
        <v-flex sm2 xs2 offset-sm1>
          <v-select
            @change="onNewPriceChange({ skiSchoolLessonTypeId: $event })"
            :value="newPrice.skiSchoolLessonTypeId"
            :items="skiLessonTypes"
            :loading="loading"
            :label="$t('skiSchool.newPriceLabels.lessonTypes')"
            item-text="name"
            item-value="id"
            hide-details
          />
        </v-flex>
        <v-flex class="ml-3" sm2 xs2>
          <v-select
            @change="onNewPriceChange({ skiSchoolSkiTypeId: $event })"
            :value="newPrice.skiSchoolSkiTypeId"
            :items="skiTypes"
            :loading="loading"
            :label="$t('skiSchool.newPriceLabels.skiTypes')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="ml-3" sm2 xs2>
          <v-select
            @change="onNewPriceChange({ numberOfPersons: $event })"
            :value="newPrice.numberOfPersons"
            :items="availableNumberOfPersons"
            :loading="loading"
            :label="$t('skiSchool.newPriceLabels.numberOfPersons')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="ml-3" sm2 xs2>
          <v-select
            @change="onNewPriceChange({ days: $event })"
            :value="newPrice.days"
            :items="availableDays"
            :loading="loading"
            :label="$t('skiSchool.newPriceLabels.numberOfDays')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="ml-3" sm2 xs2>
          <v-autocomplete
            @change="onNewPriceChange({ durationMinutes: $event })"
            :value="newPrice.durationMinutes"
            :items="availableMinutes"
            :loading="loading"
            :label="$t('skiSchool.newPriceLabels.minutes')"
            item-text="name"
            item-value="id"
            type="number"
          />
        </v-flex>
      </v-layout>
      <v-layout class="pt-3">
        <v-flex sm2 xs2 offset-sm1>
          <v-text-field
            @input="onNewPriceChange({ price: $event })"
            :value="newPrice.price"
            :placeholder="$t('skiSchool.newPriceLabels.price')"
            :disabled="loading"
            type="Number"
            min="0"
            hide-details
            solo
          />
        </v-flex>
        <v-flex class="ml-3" sm3 xs2>
          <v-text-field
            v-if="season.netOrGross === 'gross'"
            @input="onNewPriceChange({ commissionRatio: $event, contributionRatio: 0 })"
            :value="newPrice.commissionRatio"
            :placeholder="$t('ski.skiPriceSettings.commission')"
            :suffix="$t('ski.skiPriceSettings.percentageCommission')"
            :disabled="loading"
            type="Number"
            min="0"
            hide-details
            solo
          />
          <v-text-field
            v-if="season.netOrGross === 'net'"
            @input="onNewPriceChange({ contributionRatio: $event, commissionRatio: 0 })"
            :value="newPrice.contributionRatio"
            :placeholder="$t('ski.skiPriceSettings.contribution')"
            :suffix="$t('ski.skiPriceSettings.percentageContribution')"
            :disabled="loading"
            type="Number"
            min="0"
            hide-details
            solo
          />
        </v-flex>
        <v-flex class="ml-5" sm2 xs2>
          <v-btn
            @click="createPrice"
            :disabled="!canCreateNewPrice || loading"
            color="success"
            class="text-bold ml-0 mt-0"
            large
            outline
          >
            {{ $t('buttons.create') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout class="pt-3">
        <v-flex sm4 xs2 offset-sm1>
          <h3>{{ pricesWithNames.length }} {{ $t('ski.skiPrice.pricesFound') }}</h3>
        </v-flex>
      </v-layout>
    </v-card>
    <span v-if="!personCategories.length">
      <v-btn
        v-if="!loading"
        :to="`/ski/school/season/${season.id}/person-categories`"
        class="mb-2"
        color="warning"
        small
        outline
      >
        {{ $t('ski.skiPersonCategories.addMissingPersonCategories') }}
      </v-btn>
    </span>
    <span v-if="!levels.length">
      <v-btn
        v-if="!loading"
        :to="`/ski/school/season/${season.id}/levels`"
        class="mb-2"
        color="warning"
        small
        outline
      >
        {{ $t('ski.skiLevels.addMissingLevels') }}
      </v-btn>
    </span>
    <v-data-table
      v-if="personCategories.length && levels.length"
      :headers="dataHeaders"
      :items="pricesWithNames || []"
      :loading="loading"
      class="pt-5"
      disable-initial-sort
      hide-actions
    >
      <template v-slot:items="props">
        <tr style="border-bottom: none; background-color: initial !important;">
          <td :id="'price-' + props.item.id" class="font-weight-medium">
            {{ props.item.lessonTypeName }}
          </td>
          <td class="font-weight-medium">
            {{ props.item.skiTypeName }}
          </td>
          <td class="font-weight-medium text-truncate">
            {{ props.item.numberOfPersons }} <v-icon title="persons">people</v-icon>
          </td>
          <td class="font-weight-medium text-truncate">
            {{ props.item.durationMinutes }}m <v-icon title="minutes">schedule</v-icon>
          </td>
          <td class="font-weight-medium text-truncate">
            {{ props.item.days }}d <v-icon title="days">calendar_today</v-icon>
          </td>
          <td>
            <v-text-field
              @input="onPriceChange(props.item, { price: $event })"
              v-model="props.item.price"
              :placeholder="$t('ski.skiPrice.price')"
              :disabled="loading"
              type="Number"
              min="0"
              hide-details
              solo
            />
          </td>
          <td>
            <v-text-field
              v-if="season.netOrGross === 'gross'"
              @change="onPriceChange(
                props.item,
                {
                  commissionRatio: $event,
                  contributionRatio: 0
                }
              )"
              :value="props.item.commissionRatio"
              :placeholder="$t('ski.skiPriceSettings.commission')"
              :suffix="'%'"
              :disabled="loading"
              type="Number"
              min="0"
              hide-details
              solo
            />
            <v-text-field
              v-if="season.netOrGross === 'net'"
              @change="onPriceChange(
                props.item,
                {
                  contributionRatio: $event,
                  commissionRatio: 0
                }
              )"
              :value="props.item.contributionRatio"
              :placeholder="$t('ski.skiPriceSettings.contribution')"
              :suffix="'%'"
              :disabled="loading"
              type="Number"
              min="0"
              hide-details
              solo
            />
          </td>
          <td class="pt-3">
            <v-switch
              @change="onPriceChange(props.item, { webActive: $event })"
              :label="$t('ski.skiArea.showOnWeb')"
              :input-value="props.item.webActive"
            />
          </td>
          <td class="pt-2">
            <v-btn
              @click="savePrice(props.item)"
              :disabled="loading"
              color="success"
              class="ml-0 mt-0"
              small
              outline
            >
              {{ $t('buttons.update') }}
            </v-btn>
            <v-btn
              @click="removePrice(props.item.id)"
              :disabled="loading"
              class="ml-0 mt-0"
              color="error"
              small
              outline
            >
              {{ $t('buttons.remove') }}
            </v-btn>
          </td>
        </tr>
        <tr style="background-color: initial !important;">
          <td class="pb-5" colspan="9">
            <v-layout>
              <v-flex xs2 md2>
              </v-flex>
              <v-flex class="pt-3" xs3 md3>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex sm2 xs2 offset-sm1>
                {{ $t('ski.skiPrice.startDays.apply') }}
              </v-flex>
              <v-flex sm5 xs2>
                <v-select
                  @input="syncSelectedWeekdaysToBeAddedOrDeleted($event, props.item)"
                  :value="props.item.priceStartDays"
                  :items="availableStartWeekDays"
                  :loading="loading"
                  :deletable-chips="true"
                  :label="$t('ski.skiPrice.startDays.selectStartDays')"
                  item-text="name"
                  item-value="id"
                  chips
                  multiple
                />
              </v-flex>
            </v-layout>
            <v-layout class="pt-0">
              <v-flex sm2 xs2 offset-sm1>
                {{ $t('ski.skiPrice.priceCombination.apply') }}
              </v-flex>
              <v-flex sm2 xs2>
                <v-select
                  @change="setNewPriceCombination(props.item.id, {
                    skiSchoolSeasonLevelId: $event
                  })"
                  :items="levels"
                  :loading="loading"
                  :label="$t('ski.skiPrice.priceCombination.selectLevel')"
                  item-text="name"
                  item-value="id"
                  hide-details
                />
              </v-flex>
              <v-flex class="ml-3" sm3 xs3>
                <v-select
                  @change="setNewPriceCombination(props.item.id, {
                    skiSchoolSeasonPersonCategoryId: $event
                  })"
                  :items="personCategories"
                  :loading="loading"
                  :label="$t('ski.skiPrice.priceCombination.selectPersonCategories')"
                  item-text="nameWithAges"
                  item-value="id"
                  hide-details
                />
              </v-flex>
              <v-flex class="ml-3 pt-3" sm2 xs3>
                <v-btn
                  @click="addPriceCombination(props.item.id)"
                  :disabled="loading || !canAddPriceCombination(props.item)"
                  class="ml-2"
                  color="success"
                  small
                  outline
                >
                  {{ $t('buttons.add') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout
              v-for="priceCombination in props.item.priceCombinations"
              v-show="props.item.priceCombinations.length > 0"
              :key="priceCombination.id"
              class="pt-2 font-weight-medium"
            >
              <v-flex class="pt-2" sm2 xs2 offset-sm3>
                {{ priceCombination.levelName }}
              </v-flex>
              <v-flex class="ml-3 pt-2" sm3 xs3>
                {{ priceCombination.personCategoryName }}
              </v-flex>
              <v-flex sm2 xs3>
                <v-btn
                  @click="removePriceCombination(props.item.id, priceCombination.id)"
                  :disabled="loading"
                  color="error"
                  small
                  outline
                >
                  {{ $t('buttons.delete') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/school/SkiSchoolSeasonPrices.vue